import * as React from 'react';
import { FunnelPropertyConfiguration } from '../../../../../api/PropertyIntegration';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import CheckboxLabeled from '../../../../common/form/CheckboxLabeled';
import FormInput from '../../../../common/form/Input';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

interface Props {
    config?: FunnelPropertyConfiguration;
    update: (newConfig?: FunnelPropertyConfiguration) => void;
}

const FunnelConfigurationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();
    return(
    <CollapsibleCard
        cardTitle="Funnel Configuration"
        cardOpen={!!props.config}
        onCardOpenChange={open =>{
            if (isUser)  return;
            props.update(open ? { funnelCommunityId: '', useForAvailability: false, sendFloorPlan: false } : undefined)
        }}
    >
        <div>
            {props.config && (
                <>
                    <FormInput
                        labelProps={{
                            labelText: 'Community ID',
                            invalidText: 'Please enter a Funnel Community ID'
                        }}
                        inputProps={{
                            id: 'funnel-community-id',
                            name: 'funnelCommunityId',
                            value: props.config.funnelCommunityId,
                            type: 'string',
                            required: true,
                            disabled: isUser
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({
                                ...props.config!,
                                funnelCommunityId: value.toString()
                            })
                        }
                    />
                    <CheckboxLabeled
                        labelProps={{
                            labelText:
                                'Use Property Funnel Calendar for Tour Scheduling Availability?'
                        }}
                        toggle={true}
                        onChange={() =>
                            !isUser && props.update({
                                ...props.config!,
                                useForAvailability: !props.config!.useForAvailability
                            })
                        }
                        inputProps={{
                            id: 'funnel-calendar',
                            name: 'funnel-calendar',
                            checked: props.config.useForAvailability,
                            disabled: isUser
                        }}
                    />
                    <CheckboxLabeled
                        labelProps={{
                            labelText:
                                'Send Floor Plan Info to Funnel'
                        }}
                        toggle={true}
                        onChange={() =>
                            !isUser && props.update({
                                ...props.config!,
                                sendFloorPlan: !props.config!.sendFloorPlan
                            })
                        }
                        inputProps={{
                            id: 'funnel-calendar',
                            name: 'funnel-calendar',
                            checked: props.config.sendFloorPlan,
                            disabled: isUser
                        }}
                    />
                </>
            )}
        </div>
    </CollapsibleCard>
);
};
export default FunnelConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/FunnelConfigurationSection.tsx